import React, {CSSProperties, useEffect} from "react";

type BreadcrumbItem = {
    title: string,
    url: string
}

interface IEasesPageTemplateWrapper {
    children: JSX.Element | Array<JSX.Element>,
    cardClass?: string | undefined
    cardStyle: CSSProperties
    breadcrumb?: Array<string | BreadcrumbItem> | undefined,
    title?: string | undefined,
    optionsSegment?: Function | undefined
}

export default function EasasPageTemplateWrapper<T>(props: IEasesPageTemplateWrapper) {
    useEffect(() => {
        console.log("Render [EasasPageTemplateWrapper]")
        if(props.title) {
            document.title = "EA-SAS: " + props.title
        }
    }, [])

    const breadcrumbEmpty = props.breadcrumb == null || props.breadcrumb.length == 0

    return <>
    {/* === Bread crumb and options segment rendering  === */}
    { props.optionsSegment != null || !breadcrumbEmpty &&
    <div className="layout-breadcrumb" style={{paddingBottom: "12px"}}>
        <div className="breadcrumb">
            <div className="route-bar-breadcrumb">
                { !breadcrumbEmpty &&
                    props.breadcrumb?.map((item, idx) => {
                        let crumb;
                        if(typeof item == "string") {
                            crumb = <span>{item.toUpperCase()}</span>
                        } else {
                            item = item as BreadcrumbItem;
                            crumb = <a href={item.url} style={{fontWeight: 600}}>{item.title.toUpperCase()}</a>
                        }

                        return <React.Fragment key={idx}>
                            { crumb }
                            { idx < props.breadcrumb!!.length - 1 && <li style={{paddingLeft: "1rem"}}><i className="pi pi-chevron-right"/></li> }
                        </React.Fragment>
                    })
                }
            </div>
        </div>

        <div className="options-segment">
            { props.optionsSegment }
        </div>
    </div>
    }

    <div className={`card ${props.cardClass ? props.cardClass : ''}`} style={props.cardStyle}>
        {props.children}
    </div>
    </>
}